module.exports = __webpack_public_path__ + "media/images/checkStatus-Error-2bf2502e.png";